import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43cabc93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gx-5" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Base selection tabs"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-5" }, "   ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('categoryManagement'),
          mb: 2
        }, null, 8, ["title"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.categoriesUI.getError()
        }, null, 8, ["error"]),
        _createVNode(_component_MultilingualSwitcher, {
          class: "col-8",
          errors: _ctx.languageSwitchErrors,
          languages: _ctx.allLanguages,
          "active-language": _ctx.activeLanguage,
          mb: 2,
          onUpdateActiveLanguage: _ctx.changeLanguage
        }, null, 8, ["errors", "languages", "active-language", "onUpdateActiveLanguage"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'MainCategories'}]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentComponent('MainCategories')))
                }, _toDisplayString(_ctx.$t('mainCategories')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'RenameDPSubCategories'}]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentComponent('RenameDPSubCategories')))
                }, _toDisplayString(_ctx.$t('dpSubcategories')), 3),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.currentComponent === 'CustomerCategories'}]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentComponent('CustomerCategories')))
                }, _toDisplayString(_ctx.$t('ownSubCategories')), 3)
              ])
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), _normalizeProps(_guardReactiveProps(_ctx.currentProperties)), null, 16))
        ], 1024))
      ]),
      _: 1
    }),
    _hoisted_5,
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}